//SEARCH TAB FROM NAV BUTTON
window.addEventListener("load", function () {
    const searchClick = document.querySelector('.header__shopping-cart .slideout__trigger-search');
    searchClick.addEventListener("click", tab_search);
});

function tab_search() {
    const slideSearchInput = document.querySelector('#slideout-search-sidebar #searchbox-');
    slideSearchInput.focus();
}
 
